baseIsMatch